import translationsData from './assets/translations.json';

export type Language = 'en' | 'hr' | 'de';

class TranslationService {
  private currentLanguage: Language = 'en';
  private translations: any = null;

  async init(): Promise<void> {
    console.log("🌍 Loading translations...");
    this.translations = translationsData;

    if (this.translations) {
      console.log("✅ Translations loaded successfully:", Object.keys(this.translations));
    } else {
      console.error("❌ Failed to load translations - using fallback!");
      // Fallback to empty object
      this.translations = { 
        en: { common: {}, invoice: {}, footer: {}, disclaimers: {} }, 
        hr: { common: {}, invoice: {}, footer: {}, disclaimers: {} }, 
        de: { common: {}, invoice: {}, footer: {}, disclaimers: {} } 
      };
    }
  }

  // ✅ ADD THIS METHOD
  isInitialized(): boolean {
    return this.translations !== null;
  }

  setLanguage(lang: Language): void {
    this.currentLanguage = lang;
    localStorage.setItem('language', lang);
    console.log("🌍 Language changed to:", lang);
  }

  getLanguage(): Language {
    return this.currentLanguage;
  }

  t(path: string): string | string[] {
    if (!this.isInitialized()) {
      console.warn('⚠️ Translations not loaded yet!');
      return path;
    }

    const parts = path.split('.');
    
    let lang = this.currentLanguage;
    let keys = parts;
    
    if (['en', 'hr', 'de'].includes(parts[0])) {
      lang = parts[0] as Language;
      keys = parts.slice(1);
    }

    let value: any = this.translations[lang];
    
    for (const key of keys) {
      if (value && typeof value === 'object' && key in value) {
        value = value[key];
      } else {
        console.warn(`⚠️ Translation missing: ${lang}.${path}`);
        return path;
      }
    }

    return (typeof value === 'string' || Array.isArray(value)) ? value : path;
  }

  ts(path: string): string {
    const result = this.t(path);
    return Array.isArray(result) ? result.join('\n') : result;
  }

  ta(path: string): string[] {
    const result = this.t(path);
    return Array.isArray(result) ? result : [result];
  }

  loadLanguageFromStorage(): void {
    const saved = localStorage.getItem('language') as Language;
    if (saved && ['en', 'hr', 'de'].includes(saved)) {
      this.currentLanguage = saved;
      console.log("📂 Loaded language from storage:", saved);
    }
  }
}

export const translationService = new TranslationService();